import { CSSProperties } from "react";
import { Button, Spinner } from "react-bootstrap";

type FormActionButtonsProps = {
	formStatus: boolean;
	saving: boolean;
	onEdit: () => void;
	onCancel: () => void;
	saveFirst?: boolean;
	className?: string;
	style?: CSSProperties;
};

export default function FormActionButtons({ formStatus, saving, onEdit, onCancel, saveFirst = false, className, style }: FormActionButtonsProps) {
	const saveButton = (
		<Button variant="primary" className="rounded-3 shadow-sm" type="submit" disabled={saving}>
			{saving ? (
				<>
					<Spinner animation="border" size="sm" className="me-2" /> Salvando
				</>
			) : (
				"Salvar Informações"
			)}
		</Button>
	);

	const cancelButton = (
		<Button variant="light" className="rounded-3 shadow-sm" type="button" onClick={onCancel} disabled={saving}>
			Cancelar
		</Button>
	);

	return (
		<div className={`d-flex gap-2${className ? ` ${className}` : ""}`} style={style}>
			{!formStatus && (
				<Button variant="light" className="rounded-3 shadow-sm" type="button" onClick={onEdit}>
					Editar Informações
				</Button>
			)}
			{formStatus && (
				<>
					{saveFirst ? saveButton : cancelButton}
					{saveFirst ? cancelButton : saveButton}
				</>
			)}
		</div>
	);
}
